<div class="materialize check-box">
	<input #checkbox type="checkbox" id="{{inputId}}" [(ngModel)]="value" [disabled]="disabled">
	<label for="{{inputId}}" class="{{!!label ? '' : 'mb-0'}}">{{label}}</label>
	<ng-content></ng-content>
	<validation-messages *ngIf="(dirty && invalid) || formSubmitted" [messages]="failures"></validation-messages>
</div>